import type { SendNotificationRequestContent } from './sendNotificationRequestContent';
import type { SendNotificationRequestMetadata } from './sendNotificationRequestMetadata';
import type { SendNotificationRequestRecipient } from './sendNotificationRequestRecipient';
import type { SendNotificationRequestSender } from './sendNotificationRequestSender';
import type { SendNotificationRequestType } from './sendNotificationRequestType';

export interface SendNotificationRequest {
  autoSend?: boolean;
  channel: string;
  content: SendNotificationRequestContent;
  /** @nullable */
  metadata?: SendNotificationRequestMetadata;
  /** @nullable */
  notificationId?: string | null;
  priority?: string;
  recipient: SendNotificationRequestRecipient;
  /** @nullable */
  scheduledAt?: string | null;
  /** @nullable */
  sender?: SendNotificationRequestSender;
  subject: string;
  type: SendNotificationRequestType;
}
